import { GeoBounds } from '../schemas'

export function formatBounds(bounds: Array<Array<number>>): GeoBounds {
  return {
    southWest: { lat: bounds[0][1], lng: bounds[0][0] },
    northEast: { lat: bounds[1][1], lng: bounds[1][0] },
  }
}
